import React from "react";

function SettingsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38.667"
      height="38.667"
      viewBox="0 0 38.667 38.667"
      {...props}
    >
      <g id="settings" transform="translate(-0.667 -0.667)">
        <circle
          id="Ellipse_88"
          data-name="Ellipse 88"
          cx="5"
          cy="5"
          r="5"
          transform="translate(15 15)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_463"
          data-name="Path 463"
          d="M32.333,25a2.75,2.75,0,0,0,.55,3.033l.1.1a3.335,3.335,0,1,1-4.717,4.717l-.1-.1a2.772,2.772,0,0,0-4.7,1.967V35A3.333,3.333,0,0,1,16.8,35v-.15A2.75,2.75,0,0,0,15,32.333a2.75,2.75,0,0,0-3.033.55l-.1.1A3.335,3.335,0,1,1,7.15,28.267l.1-.1a2.772,2.772,0,0,0-1.967-4.7H5A3.333,3.333,0,1,1,5,16.8h.15A2.75,2.75,0,0,0,7.667,15a2.75,2.75,0,0,0-.55-3.033l-.1-.1A3.335,3.335,0,1,1,11.733,7.15l.1.1a2.75,2.75,0,0,0,3.033.55H15a2.75,2.75,0,0,0,1.667-2.517V5a3.333,3.333,0,1,1,6.667,0v.15a2.772,2.772,0,0,0,4.7,1.967l.1-.1a3.335,3.335,0,1,1,4.717,4.717l-.1.1a2.75,2.75,0,0,0-.55,3.033V15a2.75,2.75,0,0,0,2.517,1.667H35a3.333,3.333,0,0,1,0,6.667h-.15A2.75,2.75,0,0,0,32.333,25Z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default SettingsIcon;
